import * as joint from "jointjs";
import { withSvgTooltip } from "../tooltips";

export const editNodeTool = withSvgTooltip(
  new joint.elementTools.Button({
    markup: [
      {
        tagName: "circle",
        selector: "button",
        attributes: {
          cx: 10,
          cy: 10,
          r: 10,
          fill: "#FFFFFF",
          cursor: "pointer",
        },
      },
      {
        tagName: "path",
        attributes: {
          fill: "none",
          stroke: "black",
          "stroke-width": 2,
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          transform: "translate(10 10)",
          d: "M -4 -4 L 2 -4 M -4 0 L 4 0 M -4 4 L 1 4 M 2.5 -4.5 L 4.5 -2.5 M 1.5 -1.5 L 4.5 -4.5",
          cursor: "pointer",
        },
      },
    ],
    x: "0%",
    y: "100%",
    offset: { x: -10, y: 10 },
    action: function () {
      // @ts-ignore
      this.paper?.nodeClb?.(this.model);
    },
  }),
  "Edit node (Double click)",
);
